import {
    createToolbarConfig,
    uuidv4,
    XFlowGroupCommands,
    XFlowNodeCommands,
    XFlowGraphCommands,
    IconStore,
    MODELS,
} from '@antv/xflow';
import {
    UngroupOutlined,
    SaveOutlined,
    GroupOutlined,
    GatewayOutlined,
    UndoOutlined,
    RedoOutlined,
    VerticalAlignTopOutlined,
    VerticalAlignBottomOutlined,
    CopyOutlined,
    SnippetsOutlined,
    DownloadOutlined,
} from '@ant-design/icons';

const GROUP_NODE_RENDER_ID = 'GROUP_NODE_RENDER_ID';
export let TOOLBAR_ITEMS;
(function (TOOLBAR_ITEMS) {
    TOOLBAR_ITEMS.BACK_NODE = XFlowNodeCommands.BACK_NODE.id;
    TOOLBAR_ITEMS.FRONT_NODE = XFlowNodeCommands.FRONT_NODE.id;
    TOOLBAR_ITEMS.SAVE_GRAPH_DATA = XFlowGraphCommands.SAVE_GRAPH_DATA.id;
    TOOLBAR_ITEMS.REDO_CMD = `${XFlowGraphCommands.REDO_CMD.id}`;
    TOOLBAR_ITEMS.UNDO_CMD = `${XFlowGraphCommands.UNDO_CMD.id}`;
    TOOLBAR_ITEMS.MULTI_SELECT = `${XFlowGraphCommands.GRAPH_TOGGLE_MULTI_SELECT.id}`;
    TOOLBAR_ITEMS.ADD_GROUP = `${XFlowGroupCommands.ADD_GROUP.id}`;
    TOOLBAR_ITEMS.DEL_GROUP = `${XFlowGroupCommands.DEL_GROUP.id}`;
    TOOLBAR_ITEMS.COPY = `${XFlowGraphCommands.GRAPH_COPY.id}`;
    TOOLBAR_ITEMS.PASTE = `${XFlowGraphCommands.GRAPH_PASTE.id}`;
})(TOOLBAR_ITEMS || (TOOLBAR_ITEMS = {}));
let NSToolbarConfig;
(function (NSToolbarConfig) {
    NSToolbarConfig.getDependencies = async (modelService) => {
        return [
            await MODELS.SELECTED_NODES.getModel(modelService),
            await MODELS.GRAPH_ENABLE_MULTI_SELECT.getModel(modelService),
        ];
    };
    /** toolbar依赖的状态 */
    NSToolbarConfig.getToolbarState = async (modelService) => {
        // isMultiSelectionActive
        const { isEnable: isMultiSelectionActive } =
            await MODELS.GRAPH_ENABLE_MULTI_SELECT.useValue(modelService);
        // isGroupSelected
        const isGroupSelected = await MODELS.IS_GROUP_SELECTED.useValue(
            modelService
        );
        // isNormalNodesSelected: node不能是GroupNode
        const isNormalNodesSelected =
            await MODELS.IS_NORMAL_NODES_SELECTED.useValue(modelService);
        // undo redo
        const isUndoable = await MODELS.COMMAND_UNDOABLE.useValue(modelService);
        const isRedoable = await MODELS.COMMAND_REDOABLE.useValue(modelService);
        return {
            isUndoable,
            isRedoable,
            isNodeSelected: isNormalNodesSelected,
            isGroupSelected,
            isMultiSelectionActive,
        };
    };
    NSToolbarConfig.getToolbarItems = async (state, btnRef, setValueSave) => {
        const toolbarGroup = [];

        toolbarGroup.push({
            tooltip: 'Front',
            iconName: 'VerticalAlignTopOutlined',
            id: TOOLBAR_ITEMS.FRONT_NODE,
            isEnabled: state.isNodeSelected,
            onClick: async ({ commandService, modelService }) => {
                const node = await MODELS.SELECTED_NODE.useValue(modelService);
                commandService.executeCommand(TOOLBAR_ITEMS.FRONT_NODE, {
                    nodeId: node === null || node === void 0 ? void 0 : node.id,
                });
            },
        });
        /** BACK_NODE */
        toolbarGroup.push({
            tooltip: 'Back',
            iconName: 'VerticalAlignBottomOutlined',
            id: TOOLBAR_ITEMS.BACK_NODE,
            isEnabled: state.isNodeSelected,
            onClick: async ({ commandService, modelService }) => {
                const node = await MODELS.SELECTED_NODE.useValue(modelService);
                commandService.executeCommand(TOOLBAR_ITEMS.BACK_NODE, {
                    nodeId: node === null || node === void 0 ? void 0 : node.id,
                });
            },
        });
        /** 开启框选 */
        toolbarGroup.push({
            tooltip: 'Multi Select',
            iconName: 'GatewayOutlined',
            id: TOOLBAR_ITEMS.MULTI_SELECT,
            active: state.isMultiSelectionActive,
            onClick: async ({ commandService }) => {
                commandService.executeCommand(TOOLBAR_ITEMS.MULTI_SELECT, {});
            },
        });
        /** 新建群组 */
        toolbarGroup.push({
            tooltip: 'Add group',
            iconName: 'GroupOutlined',
            id: TOOLBAR_ITEMS.ADD_GROUP,
            isEnabled: state.isNodeSelected,
            onClick: async ({ commandService, modelService }) => {
                const cells = await MODELS.SELECTED_CELLS.useValue(
                    modelService
                );
                const groupChildren = cells.map((cell) => cell.id);
                commandService.executeCommand(TOOLBAR_ITEMS.ADD_GROUP, {
                    nodeConfig: {
                        id: uuidv4(),
                        renderKey: GROUP_NODE_RENDER_ID,
                        groupChildren,
                        groupCollapsedSize: { width: 200, height: 40 },
                        label: 'Group Name',
                    },
                });
            },
        });
        /** 解散群组 */
        toolbarGroup.push({
            tooltip: 'Delete group',
            iconName: 'UngroupOutlined',
            id: TOOLBAR_ITEMS.DEL_GROUP,
            isEnabled: state.isGroupSelected,
            onClick: async ({ commandService, modelService }) => {
                const cell = await MODELS.SELECTED_NODE.useValue(modelService);
                const nodeConfig = cell.getData();
                commandService.executeCommand(XFlowGroupCommands.DEL_GROUP.id, {
                    nodeConfig: nodeConfig,
                });
            },
        });
        /** 保存数据 */
        toolbarGroup.push({
            tooltip: 'Save',
            iconName: 'SaveOutlined',
            id: TOOLBAR_ITEMS.SAVE_GRAPH_DATA,
            onClick: async ({ commandService }) => {
                commandService.executeCommand(TOOLBAR_ITEMS.SAVE_GRAPH_DATA, {
                    saveGraphDataService: async (meta, graphData) => {
                        await setValueSave(graphData);
                        await btnRef.current.click();
                        return null;
                    },
                });
            },
        });
        // toolbarGroup.push({
        //     tooltip: 'Save Image',
        //     iconName: 'DownloadOutlined',
        //     // id: TOOLBAR_ITEMS.SAVE_GRAPH_DATA,
        //     onClick: async ({ commandService }) => {
        //         const xflow =
        //             document.getElementsByClassName('xflow-canvas-root');
        //         htmlToImage
        //             .toPng(document.getElementById(xflow[0].id))
        //             .then(function (dataUrl) {
        //                 let link = document.createElement('a');
        //                 link.download = 'data-flow.png';
        //                 link.href = dataUrl;
        //                 link.click();
        //             });
        //     },
        // });
        return [
            {
                name: 'graphData',
                items: toolbarGroup,
            },
        ];
    };
    NSToolbarConfig.getExtraToolbarItems = async () => {
        const toolbarGroup = [];
        /** 保存数据 */
        toolbarGroup.push({
            id: XFlowNodeCommands.MOVE_NODE.id + 'text only',
            text: '添加节点',
            tooltip: '添加节点，配置extraGroups',
        });

        return [{ name: 'extra', items: toolbarGroup }];
    };
})(NSToolbarConfig || (NSToolbarConfig = {}));
/** 注册icon 类型 */
const registerIcon = () => {
    IconStore.set('SaveOutlined', SaveOutlined);
    IconStore.set('DownloadOutlined', DownloadOutlined);
    IconStore.set('UndoOutlined', UndoOutlined);
    IconStore.set('RedoOutlined', RedoOutlined);
    IconStore.set('VerticalAlignTopOutlined', VerticalAlignTopOutlined);
    IconStore.set('VerticalAlignBottomOutlined', VerticalAlignBottomOutlined);
    IconStore.set('GatewayOutlined', GatewayOutlined);
    IconStore.set('GroupOutlined', GroupOutlined);
    IconStore.set('UngroupOutlined', UngroupOutlined);
    IconStore.set('CopyOutlined', CopyOutlined);
    IconStore.set('SnippetsOutlined', SnippetsOutlined);
};
export const useToolbarConfig = (btnRef, setValueSave) =>
    createToolbarConfig((toolbarConfig, proxy) => {
        registerIcon();

        /** 生产 toolbar item */
        toolbarConfig.setToolbarModelService(
            async (toolbarModel, modelService, toDispose) => {
                const updateToolbarModel = async () => {
                    const state = await NSToolbarConfig.getToolbarState(
                        modelService
                    );
                    const toolbarItems = await NSToolbarConfig.getToolbarItems(
                        state,
                        btnRef,
                        setValueSave
                    );
                    // const extraToolbarItems = await NSToolbarConfig.getExtraToolbarItems();
                    toolbarModel.setValue((toolbar) => {
                        toolbar.mainGroups = toolbarItems;
                        // toolbar.extraGroups = extraToolbarItems;
                    });
                };
                const models = await NSToolbarConfig.getDependencies(
                    modelService
                );
                const subscriptions = models.map((model) => {
                    return model.watch(async () => {
                        updateToolbarModel();
                    });
                });
                toDispose.pushAll(subscriptions);
            }
        );
    });
